import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button } from "../../assets/button";
import { LogoIcon } from "../../assets/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Header() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleSectionChange = (id) => {
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        if (id === "home") {
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, 100);
    } else {
      if (id === "home") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  };

  const navItemClass =
    "cursor-pointer px-3 md:px-5 py-2 font-manrope text-xs md:text-sm font-semibold text-gray-700 hover:text-[#5072F1] transition-colors";

  return (
    <header className="sticky top-0 z-50 overflow-hidden bg-white/95 backdrop-blur-md border-b border-gray-100" id="home">
      <div className="container mx-auto py-3.5 md:py-4 px-4 md:px-8 flex items-center justify-between">
        <div
          className="flex items-center gap-2 cursor-pointer"
          onClick={() => handleSectionChange("home")}
        >
          <LogoIcon />

          <p className="font-manrope text-[16px] font-extrabold leading-tight text-[#333333] md:text-[18px] 2xl:text-[22px]">
            Geo <span className="text-[#5072F1]">VPN</span>
          </p>
        </div>

        <nav className="text-[#333333] flex items-center">
          <ul className="m-0 flex justify-center items-center gap-2 md:gap-6 lg:gap-8 p-0">
            <li
              className={navItemClass}
              onClick={() => handleSectionChange("home")}
            >
              Home
            </li>
            <li
              className={navItemClass}
              onClick={() => handleSectionChange("feature")}
            >
              Features
            </li>
         
            <li
              className={`${navItemClass} hidden md:block`}
              onClick={() => handleSectionChange("footer")}
            >
              Contact
            </li>
            <li className={`${navItemClass} hidden md:block`}>
              <Link
                to="/privacy-policy"
                className="text-inherit no-underline hover:text-[#5072F1] transition-colors"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                Privacy
              </Link>
            </li>
               <li className={navItemClass}>
              <Link
                to="/blogs"
                className="text-inherit no-underline hover:text-[#5072F1] transition-colors"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                Blogs
              </Link>
            </li>
          </ul>
        </nav>

        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://play.google.com/store/apps/details?id=com.fast.secure.proxyvpn.unlimitedproxy.security&hl=en_US&gl=US"
          className="hidden cursor-pointer md:block"
        >
          <Button />
        </a>
      </div>
      <ToastContainer />
    </header>
  );
}
